import { render, staticRenderFns } from "./proformaAdd.vue?vue&type=template&id=2988a6f8"
import script from "./proformaAdd.vue?vue&type=script&lang=js"
export * from "./proformaAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports